var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBybit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1952_34872)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 12.9996,
    rx: 13,
    ry: 12.9996,
    fill: "#F6A500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2541 15.1391V10H18.2875V15.1391H17.2541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21451 16.6655H3V11.5264H5.12593C6.15937 11.5264 6.76024 12.0889 6.76024 12.9702C6.76024 13.5401 6.37344 13.9092 6.10622 14.0317C6.42511 14.1764 6.83406 14.5012 6.83406 15.1862C6.83406 16.1458 6.15789 16.6655 5.21451 16.6655ZM5.04326 12.421H4.03196V13.6051H5.04326C5.48173 13.6051 5.7268 13.3674 5.7268 13.013C5.7268 12.6602 5.48173 12.421 5.04326 12.421ZM5.10969 14.5071H4.03196V15.7708H5.10969C5.57769 15.7708 5.80062 15.483 5.80062 15.136C5.80062 14.7891 5.57769 14.5086 5.10969 14.5086V14.5071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98607 14.5573V16.6655H8.96002V14.5573L7.37 11.5264H8.49201L9.47969 13.5977L10.4541 11.5264H11.5761L9.98607 14.5573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5051 16.6655H12.2906V11.5264H14.4166C15.45 11.5264 16.0509 12.0889 16.0509 12.9702C16.0509 13.5401 15.6641 13.9092 15.3968 14.0317C15.7157 14.1764 16.1247 14.5012 16.1247 15.1862C16.1247 16.1458 15.4485 16.6655 14.5051 16.6655ZM14.3339 12.421H13.3226V13.6051H14.3339C14.7723 13.6051 15.0174 13.3674 15.0174 13.013C15.0174 12.6602 14.7723 12.421 14.3339 12.421ZM14.4003 14.5071H13.3226V15.7708H14.4003C14.8683 15.7708 15.0912 15.483 15.0912 15.136C15.0912 14.7891 14.8683 14.5086 14.4003 14.5086V14.5071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6167 12.421V16.6655H20.5847V12.421H19.2014V11.5264H23V12.421H21.6167Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1952_34872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBybit);
export default __webpack_public_path__ + "static/media/bybit.646b19fbe2d5bd9bfd45b1ceb3573031.svg";
export { ForwardRef as ReactComponent };